// Core
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

// BFX
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { SystemControlPromiseLookupService } from "shared/cubiq-services";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BfxAppStatusService {
  private _statusFromSource: BehaviorSubject<CubiqTS.SystemControlImpl[]> = new BehaviorSubject([]);
  private status: Array<CubiqTS.SystemControlImpl> = [];
  public castChange: Observable<CubiqTS.SystemControlImpl[]> =
    this._statusFromSource.asObservable();

  constructor(private systemContolPromiseService: SystemControlPromiseLookupService) {
    this.loadAll();
  }

  private loadAll(): void {
    this.systemContolPromiseService.getModelUpdateSubject().subscribe((systemControlValue: any) => {
      this.changeStatus(systemControlValue);
    });

    this.systemContolPromiseService.isPrimed().then(() => {
      this.systemContolPromiseService.getAll().then((values) => {
        if (values) {
          values.forEach((element) => {
            this.changeStatus(element);
          });
        }
      });
    });
  }

  public changeStatus(systemControlValue): void {
    let idx: number = this.status.findIndex((item) => {
      return item.systemControlSubType === systemControlValue.systemControlSubType;
    });
    // remove panic
    if (CubiqTS.SystemControlStatus.ONLINE === systemControlValue.systemControlStatus) {
      if (idx > -1) {
        this.status.splice(idx, 1);
      }
    } else {
      // add/update panic
      if (idx > -1) {
        this.status.splice(idx, 1, systemControlValue);
      } else {
        this.status.push(systemControlValue);
      }
    }
    this._statusFromSource.next(this.status);
  }

  public isMonitorChangePanicOn(): boolean {
    return (
      this.status.length > 0 &&
      this.status.find((p) => {
        return p.systemControlSubType === CubiqTS.SystemControlSubType.ORDERMONITOR_CHANGE_PANIC;
      }) !== undefined
    );
  }
}
